// extracted by mini-css-extract-plugin
module.exports = {"leftRight":"leftRight___2Sf2f","Slider":"Slider___2RjLf","rightContent":"rightContent___1FdLM","rightContent_inner":"rightContent_inner___3TQyh"};